<section class="linked-products-section">
  <div class="container-title">
    {{ 'text_linkedProducts' | dbText }}
  </div>
  <div class="form-container" [formGroup]="linkedProductsForm">
    <div class="field-wrapper">
      <div class="field-label">
        {{ 'text_upsells' | dbText }}
        <i class="db-icon db-icon-ds-info-bg ml0"
           [dsTooltip]="'text_productsPromoteSingle'|dbText"
           dsTooltipPosition="right"
           dsTooltipColor="black"
           dsTooltipAlign="top">
        </i>
      </div>
      <ds-chip-input [placeholder]="'text_chooseAProduct' | dbText"
                     [options]="allProducts"
                     [listForm]="linkedProductsForm.get('upsells') | toFormControl">
      </ds-chip-input>
    </div>
    <div class="field-wrapper">
      <div class="field-label">
        {{ 'text_crossSells' | dbText }}
        <i class="db-icon db-icon-ds-info-bg ml0"
           [dsTooltip]="'text_productsPromoteCart'|dbText"
           dsTooltipPosition="right"
           dsTooltipColor="black"
           dsTooltipAlign="top"></i>
      </div>
      <ds-chip-input [placeholder]="'text_chooseAProduct' | dbText"
                     [options]="allProducts"
                     [listForm]="linkedProductsForm.get('cross_sells') | toFormControl"></ds-chip-input>
    </div>
  </div>
</section>
